import type React from 'react';

import styles from './styles';
import Box from '@material-ui/core/Box';

export interface BannerIconProps {
  icon?: React.ReactNode;
  color?: string;
}

const BannerIcon = ({ icon, color }: BannerIconProps) => (
  <Box display='flex' className={styles.icon(color)}>
    {icon}
  </Box>
);

export default BannerIcon;
